module.exports = __webpack_public_path__ + "static/media/exclamation_red.d074d0b8.svg";